<div class="payper-message-container" *ngIf="showPayPerCanceledMessage">
    <div class="payper-message-inner fx-center-vertical">
        <div class="payper-message-inner-container">
            <div class="payper-message-section">
                <div class="payper-message-icon">
                    <svg class="nu-icon nu-icon-med">
                        <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-warning-fill"></use>
                    </svg>
                </div>
                <div class="payper-message-text body">
                    <span>
                        {{translate.get( 'PAYPER_MESSAGE.SUB_EXPIRED' )|async}}
                    </span>
                    <a
                        class="payper-message-auth-link btn-link body--bold"
                        data-testid="signup-link"
                        (click)="renewSubscription()">
                        {{translate.get( 'PAYPER_MESSAGE.RENEW_SUB' )|async}}
                    </a>
                </div>
            </div>
            <div class="payper-message-section">
                <div class="payper-message-text body">
                    <span>
                        {{translate.get( 'PAYPER_MESSAGE.UPGRADE_UNLOCK_PREMIUM' )|async}} 
                    </span>
                    <a
                        class="payper-message-auth-link btn-link body--bold"
                        data-testid="signup-link"
                        (click)="showPlanPage()">
                        {{translate.get( 'PAYPER_MESSAGE.UPGRADE_NOW' )|async}} 
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
